<template>
    <div>
        <form class="payment-form" v-if=" showFormIdentification ">

            <!-- Mineur -->
            <div class="element-wrap element-wrap-on-left">
                <div class="element-label" style="display: flex; align-items: center;">
                    <input type="checkbox" class="element-is-input" name="mineur"
                           style="width: 2.6%; height: 18px; display: initial; margin-right: 6px;"
                           @input=" isUnderage($event) " :checked="value.mineur ? 'checked' : ''"
                    >
                    <span class="mr-2">Vous êtes mineur ( Fournir une autorisation parentale ) ? </span>  (Optionnel)
                </div>

            </div>
            <!-- Mineur -->

            <!-- Copies numerisees de la piece du parent -->
            <div class="element-pair mt-4" v-if="value.mineur">
                <div class="element-pair-container">
                    <div class="element-wrap element-wrap-on-left">
                        <div class="element-label">
                            <span>Copie numérisée de la pièce d'identité du parent (PDF)</span>
                        </div>
                        <input type="file" @change="uploadPieceParent" ref="pieceParent" class="element-is-input" accept=".pdf" name="pieceParent"/>
                    </div>
                </div>
            </div>
            <!-- Copies numerisees de la piece du parent -->

            <!-- Type de piece -->
            <div class="element-wrap element-wrap-for-select element-wrap-on-left">
                <div class="element-label">
                    <span>Type de la pièce d'identité</span>
                </div>
                <select class="element-is-select" name="piece" v-model="value.typePiece">
                    <option value="" selected disabled>
                        Sélectionnez un type de pièce
                    </option>
                    <option value="Attestation d'identité">
                        Attestation d'identité
                    </option>
                    <option value="CNI">
                        CNI
                    </option>
                    <option value="Carte consulaire">
                        Carte consulaire
                    </option>
                    <option value="Passeport">
                        Passeport
                    </option>
                    <option value="Titre de séjour">
                        Titre de séjour
                    </option>
                </select>
            </div>
            <!-- Type de piece -->

            <!-- Numero de la piece -->
            <div class="element-wrap element-wrap-on-left">
                <div class="element-label">
                    <span>Numéro de la pièce d'identité</span>
                </div>
                <input type="text" class="element-is-input" name="numero_piece" v-model="value.numeroPiece"/>
            </div>
            <!-- Numero de la piece -->

            <!-- Dates pièce -->
            <div class="element-pair mt-4">
                <div class="element-pair-container">
                    <!-- Date d'emission de la piece -->
                    <div class="element-wrap element-wrap-on-left">
                        <div class="element-label">
                            <span>Date d'émission de la pièce d'identité</span>
                        </div>
                        <!-- <input type="date" class="element-is-input" name="date_emission" v-model="value.dateEmission"/> -->
                        <datepicker class="element-is-input" v-model="value.dateEmission" format="yyyy-MM-dd" :disabledDates="disabledDates" :language="fr"></datepicker>
                    </div>
                    <!-- Date d'emission de la piece -->
                    <!-- Date d'expiration de la piece -->
                    <div class="element-wrap element-wrap-on-right">
                        <div class="element-label">
                            <span> Date d'expiration de la pièce d'identité </span>
                        </div>
                        <!-- <input type="date" class="element-is-input" name="date_expiration" v-model="value.dateExpiration"/> -->
                        <datepicker class="element-is-input" v-model="value.dateExpiration" format="yyyy-MM-dd" :disabledDates="disabledDates2" :language="fr"></datepicker>
                    </div>
                    <!-- Date d'expiration de la piece -->
                </div>
            </div>
            <!-- Dates pièce -->

            <!-- Copies numerisees de la piece -->
            <div class="element-pair mt-4">
                <div class="element-pair-container">
                    <!-- Recto -->
                    <div class="element-wrap element-wrap-on-left">
                        <div class="element-label">
                            <span> Copie numérisée de la pièce d'identité </span>
                        </div>
                        <input type="file" @change="uploadPiece" ref="piece" class="element-is-input" accept=".pdf, .jpg, .jpeg, .png" name="piece"/>
                    </div>
                </div>
            </div>
            <!-- Copies numerisees de la piece du parent -->

            <!-- Informations relatives aux fichiers -->
            <div class="element-pair mt-5">
                <span class="font-15">
                    1 Seul fichier limité à 10Mo. <br> Types autorisés : pdf, jpg, png, jpeg
                </span>
            </div>
            <!-- Informations relatives aux fichiers -->

            <!-- Boutons -->
            <div class="mt-5" style="display: flex; justify-content: space-between; align-items: center;">

                <i class="fas fa-arrow-left font-18 text-dark" @click="formInfosReturn2" style="cursor: pointer;"></i>

                <button type="button" @click="formPaiementNext2" :disabled = " !value.typePiece || !value.numeroPiece || !value.dateEmission || !value.dateExpiration || !value.piece "
                    :class=" !value.typePiece || !value.numeroPiece || !value.dateEmission || !value.dateExpiration || !value.piece ? 'btn btn-sm btn-dark btn-disabled-custom font-14' : 'btn btn-sm btn-dark font-14' "
                    style="font-weight: bold;"> Valider les informations </button>
            </div>
            <!-- Boutons -->

        </form>
    </div>
</template>

<script>


    import Datepicker from 'vuejs-datepicker';
    import {fr} from 'vuejs-datepicker/dist/locale';

    export default {
        components:{
            'datepicker': Datepicker
        },
        data() {
            return {
                fr: fr,
                format: "yyyy-MM-dd",
                disabledDates: {
                    // to: new Date(2023, 0, 1), // Disable all dates up to specific date
                    // from: new Date(2023, 0, 31), // Disable all dates after specific date
                    // to: new Date(Date.now() - 8640000)
                    from: new Date( Date.now() )
                },
                disabledDates2: {
                    // to: new Date(2023, 0, 1), // Disable all dates up to specific date
                    // from: new Date(2023, 0, 31), // Disable all dates after specific date
                    to: new Date( Date.now() )
                    // from: new Date()
                }
            }
        },
        props: {
            value: {
                type: Object
            },
            value2: {
                type: Object
            },
            showFormIdentification : {
                type: Boolean
            },
            formInfosReturn : { type: Function }, formPaiementNext: { type: Function },
        },
        mounted(){
        },
        methods: {

            formInfosReturn2()
            {
                this.formInfosReturn() ;
            },

            formPaiementNext2()
            {
                this.formPaiementNext() ;
            },

            // Choisir un fichier png, jpg ou jpeg
            uploadPiece()
            {
                if ( this.$refs.piece.files[0].size > 10_000_000 )
                {
                    // File is to big > 10Mo
                    this.$swal({
                        title: 'Fichier volumineux !',
                        icon: 'info',
                        html:"<span class='font-18' style='line-height: 1.6'>Votre fichier dépasse la limite autorisée.</span>",
                    });

                    this.$refs.piece.value = null ;
                    return false;
                }

                this.value.piece = this.$refs.piece.files[0];
                // console.log(this.$refs.piece.files[0])
            },

            uploadPieceParent()
            {
                if ( this.$refs.pieceParent.files[0].size > 10_000_000 )
                {
                    // File is to big > 10Mo
                    this.$swal({
                        title: 'Fichier volumineux !',
                        icon: 'info',
                        html:"<span class='font-18' style='line-height: 1.6'>Votre fichier dépasse la limite autorisée.</span>",
                    });

                    this.$refs.pieceParent.value = null ;
                    return false;
                }

                this.value.pieceParent = this.$refs.pieceParent.files[0];
                // console.log(this.$refs.pieceParent.files[0])
            },

            isUnderage(event)
            {
                this.value.mineur = event.target.checked ;
                // console.log(event.target.checked)
            },

        },
        watch: {

            value() {
                this.$emit('input', this.value);
            }
        }
    }
</script>

<style scoped>

    table { width:100%; }
    .intitule { font-weight:normal; color:#333;}

    .pos-relative{
        position: relative;
    }

    .pos-relative .line {
        position: relative;
        padding-top: 20px;
    }

    .pos-relative .line:after {
        content: "";
        position: relative;
        left: 40%;
        width: 20%;
        height: 2px;
        background: #faaa13;
        top: -115px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
    }

    .pos-relative2{
        position: relative;
    }

    .pos-relative2 .line2 {
        position: relative;
        padding-top: 50px;
    }

    .pos-relative2 .line2:after {
        content: "";
        position: absolute;
        left: 40%;
        width: 20%;
        height: 4px;
        background: #dfe2e5;
        top: 20px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        /*border-radius: 20px;*/
    }

    .floating-container {
        position: fixed;
        width: auto;
        /* height: 100px; */
        bottom: 40px;
        right: 0;
        margin: 30px 25px;
        z-index: 20;
    }

    .custom-shadow{
        box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px !important;
    }

    .content {
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: auto;
        overflow: hidden;
    }

    .custom-rounded {
        border-radius: 32px;
    }

    .shadow{
        box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px !important;
        border-radius: 20px;
    }

    .menu-cabine {
        /* padding: 28px; */
        /* margin: 0 auto; */
        /*cursor: pointer;*/
    }

    .menu-cabine:hover, .menu-cabine:focus{
        /* padding: 28px; */
        /* margin: 0 auto; */
        /*cursor: pointer;*/
        /* border-radius: 5px; */
        /* box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px; */
    }

    /*.content .content-overlay {*/
    /*    background: rgba(0,0,0,0.7);*/
    /*    position: absolute;*/
    /*    height: 100%;*/
    /*    width: 100%;*/
    /*    left: 0;*/
    /*    top: 0;*/
    /*    bottom: 0;*/
    /*    right: 0;*/
    /*    opacity: 0;*/
    /*    -webkit-transition: all 0.5s ease-in-out 0s;*/
    /*    -moz-transition: all 0.5s ease-in-out 0s;*/
    /*    transition: all 0.5s ease-in-out 0s;*/
    /*    border-radius: 14px;*/
    /*}*/

    /*.content:hover .content-overlay{*/
    /*    opacity: 1;*/
    /*}*/



    .content-overlay:hover{
        transition: all 0.3s;
        border-color: #faaa13;
        border-style: solid;
        border-width: 2px;
        /*padding: 8px;*/
        border-radius: 25px;
        /*box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px !important;*/
    }

    .content-image{
        width: 100%;
    }

    .content:hover .content-details{
        top: 50%;
        left: 50%;
        opacity: 1;
    }

    .content-details {
        position: absolute;
        text-align: center;
        padding-left: 1em;
        padding-right: 1em;
        width: 100%;
        top: 50%;
        left: 50%;
        opacity: 0;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        -webkit-transition: all 0.3s ease-in-out 0s;
        -moz-transition: all 0.3s ease-in-out 0s;
        transition: all 0.3s ease-in-out 0s;
    }

    .fadeIn-top{
        top: 20%;
    }

    .content-details h3{
        color: #fff;
        font-weight: 500;
        letter-spacing: 0.15em;
        margin-bottom: 0.5em;
        text-transform: uppercase;
    }

    .content-details p{
        color: #fff;
        font-size: 0.8em;
    }

    .show-selected-mode{
        position: absolute;
        /*right: 3px;*/
        /*top: -6px;*/
        right: 17px;
        top: 18px;
        background: white;
        border-radius: 50%;
        z-index: 10;
    }

    .show-selected-mode2{
        position: absolute;
        right: 3px;
        top: -9px;
        /*right: 20px;*/
        /*top: 8px;*/
        background: white;
        border-radius: 50%;
        z-index: 10;
    }

    .btn-disabled-custom {
        background: rgb(0 0 0 / 8%);
        border: rgb(0 0 0 / 8%);
        color: #1b1e21;
        cursor: not-allowed;
    }

    .mode-rechargement {
        display: flex;
        flex-direction: column;
        cursor: pointer;
    }

    @media (max-width: 767px) {
        .content {
            width: 80%;
        }
        .show-selected-mode{
            right: 44px;
        }
    }

    .searchIcon {
        margin-left: -35px;
        cursor: pointer;
        /* color: #261b64; */
        color: #343a40;
        cursor: pointer;
        font-size: 25px;
        z-index: 50;
    }

</style>